module.exports = __webpack_public_path__ + "media/images/about_us/hands-and-leaves-b59b8268b67e36c5424f59fcc1ba0c05.png";